import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AdvanceSearchService } from '../../services/Advance-search/advance-search.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { EditDetailsPopupComponent } from './edit-details-popup/edit-details-popup.component';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-home-search',
  standalone: true,
  imports: [MatSelectModule,
    MatFormFieldModule, ReactiveFormsModule, InfiniteScrollDirective, LoaderComponent],
  templateUrl: './home-search.component.html',
  styleUrls: ['./home-search.component.scss', '../../../common-style/dropdown.scss'],
  providers: [DatePipe]
})
export class HomeSearchComponent implements OnInit, OnDestroy {
  searchType = new FormControl('profile');
  reference = new FormControl('');
  referenceInput = new FormControl('');
  pin = new FormControl('', Validators.pattern(/^\d{6}$/));
  district = new FormControl('');
  state = new FormControl('');
  bookingType = new FormControl('');
  accoType = new FormControl('');
  bookingStatus = new FormControl('');
  fromDate = new FormControl('');
  toDate = new FormControl('');

  isVisit: boolean = false
  isHide: boolean = false;
  showEdit: boolean = false;
  profileData: any = [];
  pincodeList: any = [];
  districtList: any = [];
  stateList: any = [];
  profileDetails: any;
  allStateDistrict: any;
  bookingList: any = [];
  isprofile: boolean = false;
  bookingIdDetails: any = [];
  visitData: any = []
  pageNo: number = 1
  payload: any = {}
  isAllDataLoaded: boolean = false
  isLoading: boolean = false
  isPincodeScoped: boolean = false;
  isMobile: boolean = window.innerWidth <= 768;
  private pincodeRequestId: number = 0;
  private isSearchLoading: boolean = false;
  private searchRequest?: Subscription;
  private statesRequest?: Subscription;
  private pincodeRequest?: Subscription;
  private districtRequest?: Subscription;
  private activeSearchKey: string | null = null;
  private readonly destroy$ = new Subject<void>();

  searchMaxLen: string | number = 200;

  constructor(
    private advanceService: AdvanceSearchService,
    private dialog: MatDialog,
    private date: DatePipe,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.getStates()
    if (this.searchType?.value == 'profile') {
      this.isHide = true;
      this.isprofile = true;
      this.isVisit = false;
      this.reference.setValue('familyCode');
    }
    this.referenceInput.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(item => {
      if (this.reference.value == 'name') {
        if (typeof item == 'string' && item.length < 3) {
          this.profileData = []
          this.bookingList = []
          this.visitData = []
        }
      } else if (this.reference.value == 'mobileNumber') {
        if (typeof item == 'string' && item.length < 10) {
          this.profileData = []
          this.bookingList = []
          this.visitData = []
        }
      } else {
        if (typeof item == 'string' && item.length < 12) {
          this.profileData = []
          this.bookingList = []
          this.visitData = []
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.cancelSearch();
    this.statesRequest?.unsubscribe();
    this.pincodeRequest?.unsubscribe();
    this.districtRequest?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onScroll() {
    if (
      this.getActiveResults().length === 0
      || this.isSearchLoading
      || this.isAllDataLoaded
    ) {
      return;
    }

    this.searchProfile(false);
  }

  referenceSelection(event: any) {
    if (event.value) {
      this.cancelSearch();
      this.referenceInput.setValue('');
      this.isAllDataLoaded = false;
      if (this.searchType?.value == 'profile') {
        this.pageNo = 1;
        this.profileData = [];
      } else {
        this.bookingList = [];
        this.pageNo = 1;
      }
    }
  }

  filterReg(e: Event) {
    const input = e.target as HTMLInputElement;
    const val = input?.value;
    if (!val) return;
    let regex: RegExp = /[^A-Za-z0-9]/g;

    switch (this.reference.value) {
      case 'familyCode':
        this.searchMaxLen = 12;
        regex = /[^0-9]/g;
        break;
      case 'name':
        this.searchMaxLen = 200;
        regex = /[^A-Za-z ]/g;
        break;
      case 'mobileNumber':
        this.searchMaxLen = 10;
        regex = /[^0-9]/g;
        break;
      case 'aadhaarNumber':
        this.searchMaxLen = 12;
        regex = /[^0-9]/g;
        break;
      case 'number':
        this.searchMaxLen = 100;
        regex = /[^0-9]/g;
        break;
    }

    const filtered = val.replace(regex, '');
    if (filtered !== val) {
      this.referenceInput.setValue(filtered, { emitEvent: false });
    }
  }

  allowNum(e: Event): string {
    const input = e.target as HTMLInputElement;
    const val = input?.value || '';

    const filtered = val.replace(/[^0-9]/g, '').slice(0, 6);
    if (this.pin.value !== filtered) {
      this.pin.setValue(filtered, { emitEvent: false });
    }
    return filtered;
  }

  onSelectType(event: any) {
    this.pageNo = 1;
    this.reset();
    if (event.value == 'profile') {
      this.isHide = this.isprofile = true;
      this.isVisit = false;
      this.reference.setValue('familyCode');
      this.profileData = [];
    } else if (event.value == 'visit') {
      this.isVisit = true;
      this.isHide = this.isprofile = false;
      this.reference.setValue('aadhaarNumber');
      this.visitData = [];
    } else {
      this.isHide = this.isprofile = this.isVisit = false;
      this.reference.setValue('');
      this.bookingList = [];
    }
  }
  reset() {
    this.cancelSearch();
    this.pincodeRequest?.unsubscribe();
    this.districtRequest?.unsubscribe();
    this.pincodeRequestId += 1;
    this.isPincodeScoped = false;
    this.reference.setValue('');
    this.referenceInput.setValue('');
    this.pin.setValue('');
    this.state.setValue('');
    this.district.setValue('');
    this.bookingType.setValue('');
    this.bookingStatus.setValue('');
    this.accoType.setValue('');
    this.fromDate.setValue('');
    this.toDate.setValue('');
    this.districtList = [];
    this.profileData = [];
    this.visitData = []
    this.bookingList = []
    this.pageNo = 1;
    this.isAllDataLoaded = false;
    if (this.allStateDistrict) {
      this.restoreAllStates();
    } else {
      this.getStates()
    }
  }

  searchProfile(value?: boolean) {
    if (this.pin.invalid) {
      this.pin.markAsTouched();
      this.toastService.error('Enter a valid 6-digit pincode.');
      return;
    }

    const isNewSearch = value === true;
    if (!isNewSearch && (this.isSearchLoading || this.isAllDataLoaded)) return;
    const requestedPage = isNewSearch ? 1 : this.pageNo + 1;
    this.payload = {
      page: requestedPage,
      key: this.reference?.value === 'bookingId' ? Number(this.referenceInput?.value) : this.referenceInput?.value,
      keyType: this.reference?.value,
      pincode: Number(this.pin?.value),
      state: this.state?.value,
      district: this.district?.value,
      bookingType: this.bookingType?.value,
      accommodationType: this.accoType?.value,
      bookingStatus: this.bookingStatus?.value,
      fromDate: this.date.transform(this.fromDate?.value, 'yyyy-MM-dd'),
      toDate: this.date.transform(this.toDate?.value, 'yyyy-MM-dd'),
    };
    const cleanObj = Object.fromEntries(
      Object.entries(this.payload).filter(
        ([Keys, value]) =>
          value !== null && value !== undefined && value !== '' && value !== 0
      )
    );
    const searchType = this.searchType.value;
    const searchKey = JSON.stringify({
      searchType,
      filters: Object.fromEntries(
        Object.entries(cleanObj).filter(([key]) => key !== 'page'),
      ),
    });

    if (isNewSearch && this.isSearchLoading && this.activeSearchKey === searchKey) {
      return;
    }

    if (isNewSearch) {
      this.cancelSearch();
      this.profileData = this.bookingList = this.visitData = [];
      this.pageNo = 1;
      this.isAllDataLoaded = false;
    }

    this.activeSearchKey = searchKey;
    this.isSearchLoading = true;
    this.isLoading = true;
    this.searchRequest = this.getSearchRequest(cleanObj).subscribe({
      next: (res) => {
        const rows = Array.isArray(res?.data) ? res.data : [];
        this.setActiveResults(
          isNewSearch ? rows : [...this.getActiveResults(searchType), ...rows],
          searchType,
        );
        this.isAllDataLoaded = rows.length === 0;
        if (rows.length > 0) this.pageNo = requestedPage;
        this.finishSearch();
        this.toastService.success(res?.message);
      },
      error: (err) => {
        this.finishSearch();
        this.toastService.error(err?.error?.message || 'Search failed.');
      },
    });
  }

  getPincodeDetails(pincode: string) {
    this.pincodeRequest?.unsubscribe();
    this.districtRequest?.unsubscribe();
    const requestId = ++this.pincodeRequestId;
    this.state.setValue('');
    this.district.setValue('');
    this.districtList = [];

    if (pincode.length !== 6) {
      this.isPincodeScoped = false;
      this.restoreAllStates();
      return;
    }

    this.isPincodeScoped = true;
    this.pincodeRequest = this.advanceService.fetchPincode(pincode)?.subscribe({
        next: (res) => {
          if (requestId !== this.pincodeRequestId || this.pin.value !== pincode) return;

          this.pincodeList = res.data;

          if (this.pincodeList !== undefined) {
            this.stateList = this.toStringList(this.pincodeList?.state);
            this.districtList = this.toStringList(this.pincodeList?.district);
            if (this.stateList?.length == 1) {
              this.state.setValue(this.stateList[0]);
            }

            if (this.districtList.length === 1) {
              this.district.setValue(this.districtList[0]);
              if (this.stateList.length > 1) this.resolvePincodeDistrict();
            }

          } else {
            this.state.setValue('');
            this.district.setValue('');
          }

          this.toastService.success(res.message);
        },
        error: (err) => {
          if (requestId === this.pincodeRequestId && this.pin.value === pincode) {
            this.state.setValue('');
            this.district.setValue('');
            this.stateList = [];
            this.districtList = [];
            this.toastService.error(err?.error?.message || 'Could not verify this pincode.');
          }
        },
      });
  }

  onPinInput(e: Event) {
    const pincode = this.allowNum(e);
    this.getPincodeDetails(pincode);
  }

  onDistrictChange(): void {
    if (this.isPincodeScoped) this.resolvePincodeDistrict();
  }

  getDistrict(value: any) {
    if (this.isPincodeScoped) return;
    this.districtList = this.allStateDistrict[value.value]

  }

  getStates() {
    if (this.allStateDistrict) {
      this.restoreAllStates();
      return;
    }
    if (this.statesRequest && !this.statesRequest.closed) return;

    this.isLoading = true
    this.statesRequest = this.advanceService.fetchStates().subscribe({
      next: (res) => {
        this.isLoading = false
        this.allStateDistrict = res.data
        if (!this.isPincodeScoped) this.restoreAllStates();

      },
      error: (err) => {
        if (err) {
          this.isLoading = false
          this.toastService.error(err.error.message);
        }
      },
    })
  }

  private resolvePincodeDistrict(): void {
    const pincode = String(this.pin.value ?? '');
    const district = String(this.district.value ?? '');
    if (pincode.length !== 6 || !district) return;

    if (this.stateList.length <= 1) return;

    const requestId = ++this.pincodeRequestId;
    this.state.setValue('');
    this.districtRequest?.unsubscribe();
    this.districtRequest = this.advanceService.fetchPincode(pincode, district).subscribe({
      next: (res) => {
        if (
          requestId !== this.pincodeRequestId
          || this.pin.value !== pincode
          || this.district.value !== district
        ) return;

        const states = this.toStringList(res?.data?.state);
        if (states.length === 0) {
          this.toastService.error('A state could not be resolved for this district.');
          return;
        }
        this.state.setValue(states[0]);
      },
      error: (err) => {
        if (
          requestId !== this.pincodeRequestId
          || this.pin.value !== pincode
          || this.district.value !== district
        ) return;

        this.state.setValue('');
        this.toastService.error(
          err?.error?.message || 'Could not verify the selected district.'
        );
      },
    });
  }

  private restoreAllStates(): void {
    this.stateList = this.allStateDistrict
      ? Object.keys(this.allStateDistrict).sort((a, b) => a.localeCompare(b))
      : [];
  }

  private toStringList(value: unknown): string[] {
    return Array.isArray(value)
      ? value.map((item) => String(item).trim()).filter(Boolean)
      : [];
  }

  private getSearchRequest(filters: Record<string, unknown>): Observable<any> {
    if (this.searchType.value === 'profile') {
      return this.advanceService.fetchProfile(filters);
    }
    if (this.searchType.value === 'visit') {
      return this.advanceService.fetchVisitDetails(filters);
    }
    return this.advanceService.fetchBookingDetails(filters);
  }

  private getActiveResults(searchType = this.searchType.value): any[] {
    if (searchType === 'profile') return this.profileData;
    if (searchType === 'visit') return this.visitData;
    return this.bookingList;
  }

  private setActiveResults(rows: any[], searchType = this.searchType.value): void {
    if (searchType === 'profile') {
      this.profileData = rows;
    } else if (searchType === 'visit') {
      this.visitData = rows;
    } else {
      this.bookingList = rows;
    }
  }

  private finishSearch(): void {
    this.isSearchLoading = false;
    this.isLoading = false;
    this.activeSearchKey = null;
  }

  private cancelSearch(): void {
    this.searchRequest?.unsubscribe();
    this.searchRequest = undefined;
    this.finishSearch();
  }

  back() {
    this.showEdit = false
  }

  getProfileDetails(event: any, type: string) {
    this.isLoading = true
    if (type == 'profile') {
      this.advanceService.fetchProfileDetails(event).subscribe({
      next: (res) => {
          this.isLoading = false
          this.profileDetails = [...res.data.filter((item: any) => item.isPrimaryDevotee), ...res.data.filter((item: any) => !item.isPrimaryDevotee)]
          this.showEdit = true
        },
        error: (err) => {
          if (err) {
            this.isLoading = false
            this.toastService.error(err.error.message);
          }
        },
      })
    } else {
      this.advanceService.fetchBookingId(event).subscribe({
        next: (res) => {
          this.isLoading = false
          this.bookingIdDetails = res.data
          this.showEdit = true
        },
        error: (err) => {
          if (err) {
            this.isLoading = false
            this.toastService.error(err.error.message);
          }
        },
      })
    }
  }

  editDetails(id: any, item: any) {
    const dialogRef = this.dialog.open(EditDetailsPopupComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: item,
      disableClose: true
    })
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res != undefined) {
          this.getProfileDetails(res.data.familyCode, res.data.type)
        }
      }
    })
  }
}
